/**
 * =============================================================================
 * geoip-redirect.js 
 * =============================================================================
 * Show a banner if user has been redirected
 * =============================================================================
 */

var GeoIPRedirect = {
  data: {
    selectors: {
      banner: ".banner-geoip-redirect",
      button_close: ".banner-geoip-redirect button"
    }
  },

  onReady: function() {
    var that = this;
    var hasSeen = Cookies.get('mp-geoip-dismissed') !== undefined;
    var wasRedirect = window.location.search.indexOf('redirect') !== -1;

    // If not seen banner before, and was redirected, show the banner
    if(!hasSeen && wasRedirect){
      document.querySelector(this.data.selectors.banner).classList.remove('d-none');
      document.querySelector(this.data.selectors.banner).classList.add('fade', 'show');
    }

    // When dismissed, hide the banner and set a cookie to prevent it being reshown
    document.querySelector(this.data.selectors.button_close).addEventListener("click", () => {
      Cookies.set('mp-geoip-dismissed', 'true', { expires: 3650, path: '/', domain: '.killstar.com' });
    });
  }
};

export default GeoIPRedirect;